module.exports = __webpack_public_path__ + "img/abi.c4beec2a.png";